import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip, Typography } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';

@observer
class UserPharmancyQualified extends React.Component<any> {

    public parseJSONinfo = (obj: any) => {
        let compString = '';

        if (obj.CompanyNames.length === 0) {
            compString = '';
        }
        else if (obj.CompanyNames.length === 1) {
            compString = obj.CompanyNames[0]
        }
        else {
            compString = obj.CompanyNames.join(', ')
        }
        return { Companies: compString }
    }

    public render() {
        const { alert_row } = this.props;
        const data = this.parseJSONinfo(alert_row.AlertJSON); 
        return (
            <React.Fragment>
                <Grid container={true} spacing={8}>
                    <Grid item={true} xs={2}><Typography variant='subtitle2'>New User: </Typography></Grid><Grid item={true} xs={10}><Typography>{alert_row.AlertJSON.AuthName}</Typography></Grid>
                    <Grid item={true} xs={2}><Typography variant='subtitle2'>Companies: </Typography></Grid><Grid item={true} xs={10}><Typography>{data.Companies}</Typography></Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default (
    withRouter(UserPharmancyQualified)
);


// WEBPACK FOOTER //
// ./src/modules/dashboard/Widgets/Alerts/UserPharmacyQualified.tsx